<template>
  <svg
    class="annualPassIcon productIcon"
    width="100%"
    height="100%"
    viewBox="0 0 83 90"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-miterlimit: 1.5;
    "
  >
    <rect id="Prancheta3" x="0" y="0" width="83" height="90" style="fill: none" />
    <g transform="matrix(0.762446,-0.762446,0.851947,0.851947,-25.2597,34.0254)">
      <rect
        x="5.857"
        y="30.125"
        width="57.511"
        height="32.559"
        style="fill: none; stroke: black; stroke-width: 2.62px"
      />
    </g>
    <g transform="matrix(0.878228,-0.878228,0.855989,0.855989,-35.0774,54.2764)">
      <path
        d="M58.721,42.131L58.721,37.513C58.721,37.224 58.949,36.99 59.23,36.99L60.117,36.99C60.715,37.455 61.46,37.73 62.268,37.73C63.075,37.73 63.82,37.455 64.418,36.99L65.125,36.99C65.407,36.99 65.635,37.224 65.635,37.513L65.635,42.131L58.721,42.131Z"
      />
    </g>
    <g transform="matrix(0.240731,0.240731,-0.321698,0.321698,57.0193,7.30403)">
      <rect
        x="5.857"
        y="30.125"
        width="57.511"
        height="32.559"
        style="fill: none; stroke: black; stroke-width: 4.98px"
      />
    </g>
    <g transform="matrix(0.895006,-0.895006,0.895006,0.895006,-37.4342,40.8326)">
      <circle cx="54.897" cy="41.017" r="3.002" />
    </g>
    <g transform="matrix(0.707107,-0.707107,0.707107,0.707107,-20.3359,48.3135)">
      <path
        d="M17.02,45L37.102,45"
        style="fill: none; stroke: black; stroke-width: 2px; stroke-linecap: butt"
      />
    </g>
    <g transform="matrix(0.975471,-0.975471,0.717263,0.717263,-21.8832,55.901)">
      <path
        d="M17.02,45L37.102,45"
        style="fill: none; stroke: black; stroke-width: 1.65px; stroke-linecap: butt"
      />
    </g>
    <g transform="matrix(0.975528,-0.975528,0.707107,0.707107,-17.95,59.8361)">
      <path
        d="M17.02,45L37.102,45"
        style="fill: none; stroke: black; stroke-width: 1.66px; stroke-linecap: butt"
      />
    </g>
  </svg>
</template>
